<template>
  <scrollactive
    class="nav"
    :duration="300"
    :modifyUrl="false"
    :alwaysTrack="true"
    :scrollOffset="10"
    @itemchanged="func_onItemChanged"
  >
    <a href="#landing" class="hidden scrollactive-item">{{ comp_home }}</a>
    <a href="#about" :class="['scrollactive-item', { 'bold': data_bold }]">{{ comp_about }}</a>
    <a href="#services" :class="['scrollactive-item', { 'bold': data_bold }]">{{ comp_services }}</a>
    <a href="#clients" :class="['scrollactive-item', { 'bold': data_bold }]">{{ comp_clients }}</a>
    <a href="#contact" :class="['scrollactive-item', { 'bold': data_bold }]">{{ comp_contact }}</a>
    <button @click="func_toggleLanguage" class="lang">
      <span :class="{ 'bold': data_language === 'EN' }">EN</span> / <span :class="{ 'bold': data_language === 'ES' }">ES</span>
    </button>
  </scrollactive>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    lang: { type: String, default: 'EN' }
  },
  data() {
    return {
      data_language: this.lang,
      data_bold: true
    }
  },
  computed: {
    comp_home() {
      return this.data_language === 'EN' ? 'Home' : 'Inicio';
    },
    comp_about() {
      return this.data_language === 'EN' ? 'About' : 'Acerca de';
    },
    comp_services() {
      return this.data_language === 'EN' ? 'Services' : 'Servicios';
    },
    comp_clients() {
      return this.data_language === 'EN' ? 'Clients' : 'Clientes';
    },
    comp_contact() {
      return this.data_language === 'EN' ? 'Contact' : 'Contacto';
    }
  },
  methods: {
    func_toggleLanguage() {
      this.data_language === 'EN' ? this.data_language = 'ES' : this.data_language = 'EN';
      this.$emit('change-language', this.data_language);
    },
    func_onItemChanged(event, currentItem) {
      this.data_bold = currentItem.href.includes('landing');
    }
  }
}
</script>

<style scoped>
  .nav {
    writing-mode: vertical-rl;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    padding-right: 20px;
    height: 100vh;
    width: 80px;
    font-size: var(--nav-font-size);
    letter-spacing: 1px;
  }

  .hidden {
    display: none;
  }

  .lang {
    writing-mode: horizontal-tb;
    background: transparent;
    border: 0;
    font-size: 0.7em;
    line-height: 1em;
    padding: 3px;
  }

  @media (max-width: 500px) {
    .nav {
      width: 40px;
      font-size: 0.8em;
      padding-bottom: 75px;
    }
    .lang {
      writing-mode: vertical-rl;
    }
  }

  @media (max-width: 414px) {
    .nav {
      width: 30px;
      padding-right: 15px;
      font-size: 0.7em;
    }
  }

  .lang:hover {
    cursor: pointer;
  }

  .lang:focus {
  outline: none;
  }

  .is-active {
    font-weight: 800;
    transform: rotate(180deg);
  }

  .bold {
    font-weight: 800;
  }

  a {
    line-height: 1em;
    padding: 3px;
  }
</style>